import { render, staticRenderFns } from "./EditHandOver.vue?vue&type=template&id=2e974932&scoped=true"
import script from "./EditHandOver.vue?vue&type=script&lang=js"
export * from "./EditHandOver.vue?vue&type=script&lang=js"
import style0 from "./EditHandOver.vue?vue&type=style&index=0&id=2e974932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e974932",
  null
  
)

export default component.exports